import React from 'react';
import { Plus, Trash2, Image as ImageIcon } from 'lucide-react';

const BannerManageSection = ({ banners, onAddClick, onToggleStatus, onDelete }) => (
  <div className="bg-white rounded-xl shadow p-6">
    <div className="flex justify-between items-center mb-4">
      <div>
        <h3 className="font-semibold">广告图管理</h3>
        <p className="text-sm text-gray-500 mt-0.5">H5 首页轮播展示，建议尺寸 750×300px</p>
      </div>
      <button onClick={onAddClick}
        className="flex items-center space-x-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 text-sm">
        <Plus className="w-4 h-4" />
        <span>添加广告图</span>
      </button>
    </div>
    {banners.length === 0 ? (
      <div className="text-center py-10 text-gray-400">
        <ImageIcon className="w-12 h-12 mx-auto mb-2 text-gray-300" />
        <p>暂无广告图，点击右上角添加</p>
      </div>
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {banners.map(banner => (
          <div key={banner.id}
            className={`border rounded-xl overflow-hidden ${banner.status === 'inactive' ? 'opacity-50' : ''}`}>
            <div className="h-32 bg-gray-100 overflow-hidden">
              <img src={banner.image_url} alt={banner.title} className="w-full h-full object-cover" />
            </div>
            <div className="p-3">
              <p className="text-sm font-medium truncate">{banner.title || '（无标题）'}</p>
              {banner.link_url && (
                <p className="text-xs text-blue-500 truncate mt-1">{banner.link_url}</p>
              )}
              <div className="flex items-center justify-between mt-3">
                <button onClick={() => onToggleStatus(banner)}
                  className={`text-xs px-2 py-1 rounded-full ${
                    banner.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'
                  }`}>
                  {banner.status === 'active' ? '显示中' : '已隐藏'}
                </button>
                <button onClick={() => onDelete(banner.id)}
                  className="text-red-500 hover:text-red-700 p-1">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default BannerManageSection;